<div class="tw-flex tw-justify-between tw-items-center tw-py-10 sm-max:tw-flex-col">
  <div class="tw-flex tw-items-center sm-max:tw-mb-6">
    <span> {{ label | translate }}: </span>

    <bosch-ui-option-bar [formControl]="pageSizeControl" [type]="'integrated'">
      <bosch-ui-option-bar-item *ngFor="let option of pageSizeOptions" [value]="option">
        {{ option }}
      </bosch-ui-option-bar-item>
    </bosch-ui-option-bar>
  </div>

  <bosch-ui-paginator
    [totalElements]="totalElements$ | async"
    [pageSize]="pageSize$ | async"
    [pageNumber]="pageNumber$ | async"
    (page)="onPageChanges($event)"
  ></bosch-ui-paginator>
</div>
